import { Button, Divider } from 'antd';

import { PF } from '@pages/Clients/NewClientsList/data/constants';

import type { FC, PropsWithChildren } from 'react';
interface FilterWrapperProps extends PropsWithChildren {
  onConfirm(): void;
}

export const FilterWrapper: FC<FilterWrapperProps> = ({
  onConfirm,
  children,
}) => {
  return (
    <div className={`${PF}__filter-wrapper`}>
      {children}
      <Divider className={`${PF}__filter-wrapper__divider`} />
      <Button
        type="primary"
        size="small"
        className={`${PF}__filter-wrapper__confirm-button`}
        onClick={onConfirm}
      >
        Применить
      </Button>
    </div>
  );
};
